import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './acceptedPaymentMethods.html' with { type: 'html' };

export default {
	name: 'CAcceptedPaymentMethods',
	components: {
		cSvg
	},
	props: {
		paymentMethods: {
			type: Array,
			default: () => []
		}
	},
	template
};
